import { ModuleDetailContainer } from "@features/modules/containers/ModuleDetailContainer";
import { useLocalSearchParams } from "expo-router";

const ModuleDetailRoute = () => {
	const { moduleId } = useLocalSearchParams<{ moduleId: string }>();

	return <ModuleDetailContainer moduleId={moduleId} />;
};

export default ModuleDetailRoute;
